module.exports = {
      id: "error-api-usage",
      viewBox: "0 0 88 114",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#error-api",
      toString: function () {
        return this.url;
      }
    }